import { Card, Space, Typography } from '@sravni/react-design-system';
import cn from 'classnames';

import { APP_DOWNLOAD_QR } from 'features/MobileApp/config';

import CoinsPng from '../assets/phone_coins.png';
import type { TMobileAppViewProps } from '../types/MobileApp.types';

import styles from './MobileApp.module.scss';

export const MobileAppDesktop = ({ title, subtitle, color, desktopTextBlockClassName }: TMobileAppViewProps) => (
  <Card
    color={color}
    size={16}
    className={styles.card}
  >
    <Space
      size={16}
      align="center"
      justify="space-between"
      direction="horizontal"
    >
      <Space
        size={12}
        align="center"
        direction="horizontal"
      >
        <img
          className={styles.img}
          alt="Mobile App QR Code"
          src={APP_DOWNLOAD_QR}
        />

        <Space
          size={4}
          direction="vertical"
          className={cn(styles.textBlockDesktop, desktopTextBlockClassName)}
        >
          <Typography.Text
            size={16}
            strong
          >
            {title}
          </Typography.Text>
          <Typography.Text
            className="h-color-D60"
            size={14}
          >
            {subtitle}
          </Typography.Text>
        </Space>

        <img
          className={styles.coinsDesktop}
          width={167}
          alt="coins"
          src={CoinsPng}
        />
      </Space>
    </Space>
  </Card>
);
